var CNT = global.CNT;

CNT.ngModule.run(['$rootScope', '$state', '$stateParams', 'gettextCatalog', 'T3_CabeceraPresentacionService', 'T3_TrazaService', '$ocLazyLoad',
    function ($rootScope, $state, $stateParams, gettextCatalog, T3_CabeceraPresentacionService, T3_TrazaService, $ocLazyLoad) {
        T3_CabeceraPresentacionService.initializeHead(CNT.name);
        var actualLocalLanguageStorage = T3_CabeceraPresentacionService.getLanguage();
        gettextCatalog.currentLanguage = actualLocalLanguageStorage;

        T3_COMUN_APP.LANGFILES.push("cgt/accessUserPassO2/lang/accessUserPassO2_es_ES.json");
        gettextCatalog.setStrings('es_ES', require("@telefonica/segu.cgt-AccessUserPassO2/src/accessUserPassO2/lang/accessUserPassO2_es_ES.json"));
        T3_COMUN_APP.LANGFILES.push("cgt/verifyOTPMobileAccessO2/lang/verifyOTPMobileAccessO2_es_ES.json");
        gettextCatalog.setStrings('es_ES', require("@telefonica/segu.cgt-VerifyOTPMobileAccessO2/src/verifyOTPMobileAccessO2/lang/verifyOTPMobileAccessO2_es_ES.json"));
    }
]);

CNT.ngModule.config(['$stateProvider', '$urlRouterProvider', '$logProvider',
    function ($stateProvider, $urlRouterProvider, $logProvider) {
        $logProvider.debugEnabled(CNT.debug);
        $urlRouterProvider.otherwise('/accessUserPassO2');
        $stateProvider.state('accessUserPassO2', {
            url: '/accessUserPassO2',
            params: {
                cgtAccessUserPassO2In: null
            },
            template: require('@telefonica/segu.cgt-AccessUserPassO2/src/accessUserPassO2/accessUserPassO2_view.html'),
            resolve: {
                loadMyCtrl: ['$ocLazyLoad', 'T3_UrlService', function ($ocLazyLoad, T3_UrlService) {
                    return function () {
                        var resolver = function () { };

                        var promise = new Promise(function (resolve) {
                            resolver = resolve;
                        });

                        require.ensure([], function () {
                            T3_UrlService.requireAll(require.context('@telefonica/segu.cgt-AccessMobileConnectO2/src/accessMobileConnectO2', false, /^.*_(constant|controller|directive|service|model)\.js$/));
                            T3_UrlService.requireAll(require.context('@telefonica/segu.cgt-AccessUserPassO2/src/accessUserPassO2', false, /^.*_(constant|controller|directive|service|model)\.js$/));
                            T3_UrlService.requireAll(require.context('@telefonica/segu.cgt-VerifyOTPMobileAccessO2/src/verifyOTPMobileAccessO2', false, /^.*_(constant|controller|directive|service|model)\.js$/));

                            $ocLazyLoad.load({ name: T3_COMUN_APP.NAME });
                            resolver($ocLazyLoad.load({ name: CNT.name }));
                        });

                        return promise;
                    }();
                }]
            }
        }).state('contactMediumO2', {
            url: '/contactMediumO2',
            params: {
                cgtContactMediumO2In: null
            },
            template: require('@telefonica/segu.cgt-ContactMediumO2/src/contactMediumO2/contactMediumO2_view.html'),
            resolve: {
                loadMyCtrl: ['$ocLazyLoad', 'T3_UrlService', function ($ocLazyLoad, T3_UrlService) {
                    return function () {
                        var resolver = function () { };

                        var promise = new Promise(function (resolve) {
                            resolver = resolve;
                        });
                        require.ensure([], function () {

                            T3_UrlService.requireAll(require.context('@telefonica/segu.cgt-ContactMediumO2/src/contactMediumO2', false, /^.*_(constant|controller|directive|service|model)\.js$/));


                            $ocLazyLoad.load({ name: T3_COMUN_APP.NAME });
                            resolver($ocLazyLoad.load({ name: CNT.name }));
                        });
                        return promise;

                    }();
                }]
            }
        }).state('verifyOTPO2', {
            url: '/verifyOTPO2',
            params: {
                cgtVerifyOTPO2In: null
            },
            template: require('@telefonica/segu.cgt-VerifyOTPO2/src/verifyOTPO2/verifyOTPO2_view.html'),
            resolve: {
                loadMyCtrl: ['$ocLazyLoad', 'T3_UrlService', function ($ocLazyLoad, T3_UrlService) {
                    return function () {
                        var resolver = function () { };

                        var promise = new Promise(function (resolve) {
                            resolver = resolve;
                        });
                        require.ensure([], function () {

                            T3_UrlService.requireAll(require.context('@telefonica/segu.cgt-VerifyOTPO2/src/verifyOTPO2', false, /^.*_(constant|controller|directive|service|model)\.js$/));


                            $ocLazyLoad.load({ name: T3_COMUN_APP.NAME });
                            resolver($ocLazyLoad.load({ name: CNT.name }));
                        });
                        return promise;

                    }();
                }]
            }
        }).state('savePasswordO2', {
            url: '/savePasswordO2',
            params: {
                cgtSavePasswordO2In: null
            },
            template: require('@telefonica/segu.cgt-SavePasswordO2/src/savePasswordO2/savePasswordO2_view.html'),
            resolve: {
                loadMyCtrl: ['$ocLazyLoad', 'T3_UrlService', function ($ocLazyLoad, T3_UrlService) {
                    return function () {
                        var resolver = function () { };

                        var promise = new Promise(function (resolve) {
                            resolver = resolve;
                        });

                        require.ensure([], function () {

                            T3_UrlService.requireAll(require.context('@telefonica/segu.cgt-SavePasswordO2/src/savePasswordO2', false, /^.*_(constant|controller|directive|service|model).js$/));


                            $ocLazyLoad.load({ name: T3_COMUN_APP.NAME });
                            resolver($ocLazyLoad.load({ name: CNT.name }));
                        });
                        return promise;

                    }();
                }]
            }
        });
    }
]);